import {inject, Provider} from "@angular/core";
import {ControlContainer} from "@angular/forms";

export const FormControlContainerProvider: Provider = {
  provide: ControlContainer,
  useFactory: () => inject(ControlContainer,  {skipSelf: true})
}
